import React from "react";
var __jsx = React.createElement;
import MiniGallery from './MiniGallery';
function MiniGalleryAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(MiniGallery, {
    miniGalleryData: entry
  });
}
export default MiniGalleryAdapter;